import { IQuery, key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-datasource';
import { APCourse, IAPCourseMeta } from '../../global/builders/ap_course_builder';
import { APCourseGroup } from '../../global/builders/ap_course_group_builder';
import { APGenericSlot, APGenericSlotBuilder } from '../../global/builders/ap_generic_slot_builder';
import { APPlannedCourse, IAPPlannedCourseMeta } from '../../global/builders/ap_planned_course_builder';
import {
  APProgramSlot,
  IAPProgramSlotMeta,
  SingleCourseProgramSlot,
  SingleCourseProgramSlotMeta
} from '../../global/builders/ap_program_slot_builder';
import { INVALID_ID } from '../../global/constants/ap_id_constants';
import { IAPCoursesDatasource } from '../../global/datasources/ap_courses_datasource';
import { APCourseServant } from '../../global/servants/ap_course_servant';

export interface IAPFavoriteCoursesQueryResult {
  courses: Array<APCourse & IAPCourseMeta>;
  courseNames: string[];
  count: number;
  genericSlots: APGenericSlot[];
}

export class APFavoriteCoursesQuery implements IQuery {
  private __result: IAPFavoriteCoursesQueryResult;

  constructor(private ngAPCoursesDatasource: IAPCoursesDatasource) {
    ORMMediator.registerQuery(this, ngAPCoursesDatasource);
  }

  run(): this {
    const apiCourses = this.ngAPCoursesDatasource.query((course) => course.is_favorite);
    const courses = this.ngAPCoursesDatasource.metasource().composes(apiCourses);

    const genericSlots = _4.map(courses, (course) => {
      return APGenericSlotBuilder.build({
        title: `${course.cd} ${course.title}`,
        type: 'COURSE',
        termId: INVALID_ID,

        course,
        isDragEnabled: true,
        credits: course.credits,
        isPlanned: false,
        disableSlot: false,
        isPlannedSomewhere: false,
        shouldShowAddToTermMenu: true,
        plannedCourse: {} as APPlannedCourse & IAPPlannedCourseMeta,
        programSlot: {
          id: null as unknown as key,
          slot_type: 'COURSE'
        } as SingleCourseProgramSlot & IAPProgramSlotMeta,
        status: course.status,
        hoverTemplate: APCourseServant.buildHoverTemplate(course)
      });
    });
    this.__result = {
      courses,
      count: _4.size(courses),
      courseNames: _4.map(courses, 'cd'),
      genericSlots
    };

    return this;
  }

  get result(): IAPFavoriteCoursesQueryResult {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPFavoriteCoursesQuery', APFavoriteCoursesQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_favorite_courses_query.ts